import React from "react";

const CarretDown = ({ style }: { style?: React.CSSProperties }) => {
	return (
		<svg
			width="19"
			height="18"
			viewBox="0 0 19 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={style}
		>
			<g id="CaretDown">
				<path
					id="Vector"
					d="M14.75 6.75L9.125 12.375L3.5 6.75"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};

export const CarretDownV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 13L10.0313 5.96875L17.0625 13" stroke="currentColor" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CarretDown;
